import makeAtom from '../../../core/makeAtom';
import type { Theme, Tools } from '../../../core/types';
import withEventTracking from '../../../utilities/withEventTracking';
import styles from './index.module.less';

interface Props {
  Component?: keyof React.ReactHTML | React.ElementType;
  children?: React.ReactNode;
  className?: string;
  theme?: Theme;
  onClick?: any;
  disabled?: boolean;
  $isActive?: boolean;
  tools?: Tools;
  qeId?: string;
  tabIndex?: string;
  id?: string;
  ref?: any;
}

export const Tab = makeAtom<Props>({
  name: 'Tab',
  rootClass: styles.root,
  styles,
  defaultProps: {
    Component: 'button',
    role: 'tab',
    theme: {
      textBody: 1,
      padding: 5,
      focusDark: true,
    },
    tools: {
      tracking: {
        methods: ['click'],
      },
    },
  },
});

/**
 * @deprecated
 * DEPRECATION NOTICE:
 * This component should not be used and will be removed [in V2](https://github.aexp.com/amex-eng/aqx-components/tree/next)
 *
 * Please migrate to the new Tabs V2 when possible.
 */
export default withEventTracking<Props>(Tab);
